/**
 * Support Domain Constants
 */

import type { TicketPriority } from '../types'

export const DEFAULT_PAGE_SIZE = 25

export const DEFAULT_SUPPORT_SORT = {
  sortBy: 'createdAt' as const,
  sortOrder: 'desc' as const,
}

export const SUPPORT_ENDPOINTS = {
  BASE: '/api/support-tickets',
} as const

export const TICKET_STATUS = {
  OPEN: 'open',
  IN_PROGRESS: 'in_progress',
  WAITING_ON_REPORTER: 'waiting_on_reporter',
  RESOLVED: 'resolved',
  CLOSED: 'closed',
} as const

export const TICKET_CATEGORY = {
  ORDER_ISSUE: 'order_issue',
  DELIVERY_ISSUE: 'delivery_issue',
  PAYMENT_ISSUE: 'payment_issue',
  ACCOUNT_ISSUE: 'account_issue',
  PLATFORM_BUG: 'platform_bug',
  MALFUNCTIONING_HARDWARE: 'malfunctioning_hardware',
  FEATURE_REQUEST: 'feature_request',
  GENERAL: 'general',
  OTHER: 'other',
} as const

export const TICKET_PRIORITY = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
  URGENT: 'urgent',
} as const

export const TICKET_CHANNEL = {
  CUSTOMER_TO_UFC: 'customer_to_ufc',
  UFC_TO_525K: 'ufc_to_525k',
} as const

export const SLA_STATUS = {
  MET: 'met',
  BREACHED: 'breached',
} as const

// Statuses that close out a ticket and require the SLA outcome to be recorded
export const TICKET_CLOSING_STATUSES = ['resolved', 'closed'] as const

// SLA resolution target (hours from open → resolved) per priority. Calendar
// hours (24/7). Used to suggest the SLA outcome when closing a ticket.
export const SLA_TARGET_HOURS: Record<TicketPriority, number> = {
  urgent: 4,
  high: 8,
  medium: 24,
  low: 72,
}

export const DEFAULT_SLA_TARGET_HOURS = 24

export const CUSTOMER_CATEGORIES = [
  TICKET_CATEGORY.ORDER_ISSUE,
  TICKET_CATEGORY.DELIVERY_ISSUE,
  TICKET_CATEGORY.PAYMENT_ISSUE,
  TICKET_CATEGORY.ACCOUNT_ISSUE,
  TICKET_CATEGORY.GENERAL,
  TICKET_CATEGORY.OTHER,
] as const

export const INTERNAL_CATEGORIES = [
  TICKET_CATEGORY.PLATFORM_BUG,
  TICKET_CATEGORY.MALFUNCTIONING_HARDWARE,
  TICKET_CATEGORY.FEATURE_REQUEST,
  TICKET_CATEGORY.GENERAL,
  TICKET_CATEGORY.OTHER,
] as const
